import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import WorkflowStepper from "../components/workflowStepper/WorkflowStepper";
import theme from "../theme/theme";

export default function AppShell() {
  const location = useLocation();
  const showWorkflowStepper = location.pathname === "/build";
  const [activeStep, setActiveStep] = useState(0);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      
      {/* Global Animated Background */}
      <div className="op-bg-container">
        <div className="op-grid-bg" />
        <div className="op-blob op-blob-a" style={{ width: 480, height: 480, top: -120, left: -140, background: "#0055FF" }} />
        <div className="op-blob op-blob-b" style={{ width: 420, height: 420, top: 80, right: -120, background: "#00B6FF" }} />
        <div className="op-blob op-blob-a" style={{ width: 360, height: 360, bottom: -100, left: "38%", background: "#0D47A1", animationDelay: "-8s" }} />
        {[...Array(14)].map((_, i) => (
          <span
            key={i}
            className="op-particle"
            style={{
              left: `${(i * 7.3 + 4) % 100}%`,
              width: 3 + (i % 3) * 2,
              height: 3 + (i % 3) * 2,
              animationDuration: `${9 + (i % 5) * 3}s`,
              animationDelay: `${(i * 1.7) % 10}s`,
            }}
          />
        ))}
      </div>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "transparent",
        }}
      >
        <Header />
        {showWorkflowStepper && <WorkflowStepper activeStep={activeStep} />}
        <Box component="main" sx={{ flex: 1, py: 2, px: { xs: 1.5, sm: 2 } }}>
          <Outlet context={{ activeStep, setActiveStep }} />
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
